<template>
  <div class="contentbox">
    <div class="conten">
      <ul class="equipment_management" :class="show_search_state?'show_search':''">
        <li class="header_search" :class="show_search_state?'show_search':''">
          <div class="search_input_box">
            <div>
              <!--<el-select v-model="search_data.assets_type" size="mini" placeholder="類型">-->
                <!--<el-option-->
                  <!--label="all"-->
                  <!--value="">-->
                <!--</el-option>-->
                <!--<el-option-->
                  <!--v-for="item in assets_list"-->
                  <!--:key="item.Devicedepartment_id"-->
                  <!--:label="item.Devicedepartment_name"-->
                  <!--:value="item.Devicedepartment_id">-->
                <!--</el-option>-->
              <!--</el-select>-->
              <!--醫生-->
              <el-select v-if="$store.state.list_class === 1"
                         @change="onsearch('field')"
                         v-model="search_data.title_name" size="mini" placeholder="類型">
                <el-option
                  label="all"
                  value="">
                </el-option>
                <el-option
                  v-for="item in Dental_search_field"
                  :key="item.title_name"
                  :label="item.title"
                  :value="item.title_name">
                </el-option>
              </el-select>
              <!--供應商-->
              <el-select v-if="$store.state.list_class === 2"
                         @change="onsearch('field')"
                         v-model="search_data.title_name" size="mini" placeholder="類型">
                <el-option
                  label="all"
                  value="">
                </el-option>
                <el-option
                  v-for="item in Supplier_search_field"
                  :key="item.title_name"
                  :label="item.title"
                  :value="item.title_name">
                </el-option>
              </el-select>
              <!--員工-->
              <el-select v-if="$store.state.list_class === 0"
                         @change="onsearch('field')"
                         v-model="search_data.title_name"
                         size="mini" placeholder="類型">
                <el-option
                  label="all"
                  value="">
                </el-option>
                <el-option
                  v-for="item in Employee_search_field"
                  :key="item.title_name"
                  :label="item.title"
                  :value="item.title_name">
                </el-option>
              </el-select>
              <el-select @change="onsearch"
                         v-model="search_data.keyword"
                         size="mini" placeholder="請選擇">
                <el-option
                  label="all"
                  value="">
                </el-option>
                <el-option
                  v-for="(item,index) in field_list"
                  :key="index"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </div>
            <div>
              <el-date-picker
                v-model="search_data.startTime"
                type="date"
                @change="onsearch"
                size="mini"
                value-format="yyyy-MM-dd"
                placeholder="保修到期日/購買日期">
              </el-date-picker>
              ~
              <el-date-picker
                v-model="search_data.endTime"
                type="date"
                @change="onsearch"
                size="mini"
                value-format="yyyy-MM-dd"
                placeholder="保修到期日/購買日期">
              </el-date-picker>
            </div>
            <div>
              <el-input @change="onsearch"
                        v-model="search_data.keyword"
                        size="mini" placeholder="關鍵字"></el-input>
            </div>
            <div>
              <el-button size="mini" type="success" @click="on_export_execl">導出</el-button>
            </div>
            <!--<div>-->
              <!--<el-button size="mini" type="success" @click="onsearch">查詢</el-button>-->
            <!--</div>-->
          </div>
          <i class="el-icon-arrow-down" @click="showsearchbox"></i>
        </li>
        <!--牙醫表頭-->
        <li v-if="$store.state.list_class === 1"
            class="header_list"
            :class="show_search_state?'show_search':''">
          <!--<div>設備名稱</div>-->
          <div>Company name</div>
          <div>Equipment no.</div>
          <div>Brands</div>
          <div>Description</div>
          <div>Model</div>
          <div>Serial no.</div>
          <!--<div>設備類型</div>-->
          <div>Date purchase</div>
          <div>Invoice no.</div>
          <div>Warranty end date</div>
          <div>User name</div>
        </li>
        <!--技工所表頭-->
        <li v-if="$store.state.list_class === 2"
            class="header_list"
            :class="show_search_state?'show_search':''">
          <!--<div>設備名稱</div>-->
          <div>公司名称</div>
          <div>設備編號</div>
          <div>品牌</div>
          <div>設備描述</div>
          <div>型號</div>
          <div>序列號</div>
          <!--<div>設備類型</div>-->
          <div>購買日期</div>
          <div>發票號碼</div>
          <div>原廠保修到期日</div>
          <div>用户名称</div>
        </li>
        <!--Tesco表頭-->
        <li v-if="$store.state.list_class === 0"
            class="header_list"
            :class="show_search_state?'show_search':''">
          <!--<div>設備名稱</div>-->
          <div>Location</div>
          <div>Customer type</div>
          <!--<div>Customer name</div>-->
          <div>Supplier</div>
          <div>Company name</div>
          <div>Brands</div>
          <div>Description</div>
          <div>Model</div>
          <div>Equipment no.</div>
          <div>Serial no.</div>
          <!--<div>設備類型</div>-->
          <div>Invoice no.</div>
          <div>Date purchase</div>
          <div>Warranty status</div>
          <div>Warranty end date</div>
          <!--<div>數量</div>-->
          <!--<div>客戶類型</div>-->
          <!--<div>客戶編號</div>-->
          <!--<div>客戶名稱</div>-->
          <div>Extend warranty end date</div>
          <div>用户名称</div>
          <div>可查看人</div>
          <div>操作員</div>
        </li>
        <!--醫生和技工所的列表-->
        <li v-if="$store.state.list_class !== 0" v-for="(itme,index) in equipment_list" :key="index" @click="new_equipment(itme.assets_id)">
          <!--<div>{{itme.assets_name}}</div>-->
          <div>{{itme.supplier}}</div>
          <div>{{itme.assets_num}}</div>
          <div>{{itme.brand_name}}</div>
          <div>{{itme.device_description}}</div>
          <div>{{itme.assets_model}}</div>
          <div>{{itme.assets_machine_number}}</div>
          <!--<div>{{itme.equipment_type}}</div>-->
          <div>{{itme.assets_buy_time_unix}}</div>
          <div>{{itme.assets_number}}</div>
          <div>{{itme.expiry_date}}</div>
          <div>{{itme.users_realname}}</div>
        </li>
        <!--Tesco列表-->
        <li v-if="$store.state.list_class === 0" v-for="(itme,index) in equipment_list" :key="index" @click="new_equipment(itme.assets_id)">
          <!--<div>{{itme.assets_name}}</div>-->
          <div>{{itme.assets_name}}</div>
          <div>{{itme.customer_type}}</div>
          <!--<div>{{itme.customers_name}}</div>-->
          <div>{{itme.customers_name}}</div>
          <div>{{itme.supplier}}</div>
          <div>{{itme.brand_name}}</div>
          <div>{{itme.device_description}}</div>
          <div>{{itme.assets_model}}</div>
          <div>{{itme.assets_num}}</div>
          <div>{{itme.assets_machine_number}}</div>
          <!--<div>{{itme.equipment_type}}</div>-->
          <div>{{itme.assets_number}}</div>
          <div>{{itme.assets_buy_time_unix}}</div>
          <div>
            <span v-if="this_date > itme.expiry_date">過期</span>
            <span v-if="this_date <= itme.expiry_date">保修內</span>
          </div>
          <div>{{itme.expiry_date}}</div>
          <!--<div>{{itme.assets_number}}</div>-->

          <!--<div>{{itme.customerID}}</div>-->
          <div>{{itme.extra_due_date}}</div>
          <div>{{itme.users_realname}}</div>
          <div>{{itme.userCanSee}}</div>
          <div>{{itme.assets_create_operator}}</div>
        </li>
      </ul>
      <div class="add_order_but" @click="new_equipment('')">
        <i class="el-icon-circle-plus-outline"></i>
      </div>
      <div class="bottom_but">
        <div v-if="$store.state.list_class === 0">
          <el-button type="success" @click="printit">
            PRINT
          </el-button>
          <el-button type="success" @click="on_export_execl">
            導出EXCEL
          </el-button>
          <el-button type="success" @click="add_import_excel_box = true">
            導入EXCEL
          </el-button>
        </div>
        <div v-else></div>

        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          background
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
        <!--<el-button v-show="list_class === 0" @click="switch_list(2)" type="success">技工所</el-button>-->
        <!--<el-button v-show="list_class === 2" @click="switch_list(1)" type="success">原列表</el-button>-->
        <!--<el-button v-show="list_class === 1" @click="switch_list(0)" type="success">員工</el-button>-->
      </div>
      <!--導入選項-->
      <mt-popup
        v-model="add_import_excel_box"
        :modal="true"
        class="add_import_excel_box"
        position="content">
        <slot>
          <div class="signature_box">
            <div>
              <input id="file" type="file">
            </div>
            <div class="paymentmethodbut">
              <mt-button @click="select_file" type="primary">確認導入</mt-button>
              <mt-button @click="add_import_excel_box = false" type="primary">取消導入</mt-button>
              <mt-button type="primary" @click="on_downloadTemplate">下載模板</mt-button>
            </div>
          </div>
        </slot>
      </mt-popup>
    </div>
  </div>
</template>

<script>
  import {MessageBox, Button, Toast} from 'mint-ui';
  import {
    get_fixedassets_all_data,
    import_excel,
    export_execl_dow_url,
    downloadTemplate,
    get_assets,
    get_fixedassets_search_data,
  } from '../../assets/js/api'

  export default {
    name: "orderlist",
    data() {
      return {
        show_search_state: false, //設備列表
        equipment_list: [], //設備列表
        add_import_excel_box:false,
        currentPage: 1,//當前頁數
        search_data:{
          assets_type: '', //搜索的類型
          title_name: '', //搜索的字段
          startTime: '', //搜索的開始時間
          endTime: '', //搜索的結束時間
          keyword: '', //搜索的關鍵字
          page: 1, //頁數
        },
        total: 0,//數據總數
        assets_list: 0,//設備類型
        // 牙醫搜索字段
        Dental_search_field:[
          {
            title:'Serial no.',
            title_name:'assets_machine_number',
          },
          {
            title:'Description',
            title_name:'device_description',
          },
          {
            title:'Brands',
            title_name:'brand_name',
          },
          {
            title:'Model',
            title_name:'assets_model',
          },
          {
            title:'Equipment no.',
            title_name:'assets_num',
          },
          {
            title:'Date purchase',
            title_name:'assets_buy_time_unix',
          },
          {
            title:'Invoice no.',
            title_name:'assets_number',
          },
          {
            title:'Company name',
            title_name:'supplier',
          },
          {
            title:'Warranty end date',
            title_name:'expiry_date',
          }

        ],
        // 供應商搜索字段
        Supplier_search_field:[
          {
            title:'序列號',
            title_name:'assets_machine_number',
          },
          {
            title:'設備描述',
            title_name:'device_description',
          },
          {
            title:'品牌',
            title_name:'brand_name',
          },
          {
            title:'型號',
            title_name:'assets_model',
          },
          {
            title:'設備編號',
            title_name:'assets_num',
          },
          {
            title:'購買日期',
            title_name:'assets_buy_time_unix',
          },
          {
            title:'發票號碼',
            title_name:'assets_number',
          },
          {
            title:'公司名称',
            title_name:'supplier',
          },
          {
            title:'原廠保修到期日',
            title_name:'expiry_date',
          }

        ],
        // 員工搜索字段
        Employee_search_field:[
          {
            title:'Location',
            title_name:'assets_name',
          },
          {
            title:'Customer type',
            title_name:'customer_type',
          },
          {
            title:'Supplier',
            title_name:'customers_name',
          },
          {
            title:'Serial no.',
            title_name:'assets_machine_number',
          },
          {
            title:'Description',
            title_name:'device_description',
          },
          {
            title:'Brands',
            title_name:'brand_name',
          },
          {
            title:'Model',
            title_name:'assets_model',
          },
          {
            title:'Equipment no.',
            title_name:'assets_num',
          },
          {
            title:'Date purchase',
            title_name:'assets_buy_time_unix',
          },
          {
            title:'Invoice no.',
            title_name:'assets_number',
          },
          {
            title:'Company name',
            title_name:'supplier',
          },
          {
            title:'Warranty end date',
            title_name:'expiry_date',
          },
          {
            title:'Extend warranty end date',
            title_name:'extra_due_date',
          },
          {
            title:'可查看人',
            title_name:'userCanSee',
          },
          {
            title:'操作員',
            title_name:'assets_create_operator',
          }
        ],
        field_list : [], // 字段列表
      }
    },
    components: {
      MessageBox,
      Button,
      Toast,
    },
    mounted() {
      this.currentPage = Number(this.$route.query.currentPage) || 1

      get_assets().then(data=>{
        if (data.status){
          this.assets_list = data.data
        }
      })

      this.this_date = this.get_this_date()

      this.onsearch()
    },
    methods: {
      // 選擇文件
      select_file(){
        let formData = new window.FormData()
        formData.append('file', document.getElementById('file').files[0])
        if (document.getElementById('file').files[0] === undefined){
          this.$message({
            type: 'warning',
            message: '請選擇需要導入的文件'
          });
          return
        }
        import_excel(formData).then(data=>{
          if (this.$store.state.client) {
            MessageBox({
              title: '提示',
              message: data.data,
            }).then(() => {
            });
          }
          else {
            this.$alert(data.data, '提示', {
              confirmButtonText: '确定',
              callback: action => {
              }
            });
          }
          this.add_import_excel_box = false
          if (data.status){
            this.onsearch()
          }
        })
      },
      on_export_execl(){
        let assets_id_arr = []
        this.equipment_list.map(itme=>{
          assets_id_arr.push(itme.assets_id)
        })
        window.open(export_execl_dow_url(assets_id_arr),'_blank')
      },
      on_downloadTemplate(){
        window.open(downloadTemplate(),'_blank')
      },
      // 搜索
      onsearch(field){
        if (field === 'field'){
          this.search_data.keyword = ''
          get_fixedassets_search_data(this.search_data.title_name).then(data=>{
            if (data.status){
              this.field_list = data.data
            }
          })
        }
        get_fixedassets_all_data(this.search_data).then(data => {
          if (data.status) {
            this.equipment_list = data.data
            this.total = Number(data.total_count)
          }
        })
      },
      // 获取当天日期
      get_this_date(){
        let myDate = new Date();
        let F = myDate.getFullYear()
        let M = myDate.getMonth()+1
        let D = myDate.getDate()
        if (M < 10){
          M = '0' + M
        }
        if (D < 10){
          D = '0' + D
        }
        return F + '-' + M + '-' + D
      },
      printit(){
        try{
          print.portrait   =  false    ;//横向打印
        }catch(e){
          alert("不支持此方法");
        }
        window.print();
      },
      showsearchbox() {
        if (this.show_search_state) {
          this.show_search_state = false
        }
        else {
          this.show_search_state = true
        }
      },
      //切換列表
      switch_list(list_class) {
        this.list_class = list_class
        if (this.list_class === 2) {
          this.$message({
            type: 'success',
            message: '已切換至供應商列表!'
          });
        }
        else if (this.list_class === 1) {
          this.$message({
            type: 'success',
            message: '已切換回原列表!'
          });
        }
        else {
          this.$message({
            type: 'success',
            message: '已切換至員工列表!'
          });
        }
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.search_data.page = val
        this.onsearch()
        // console.log(`当前页: ${val}`);
      },
      new_equipment(id){
        // 新增設備
        this.$router.push({path: '/orderlist/equipment_details?id=' + id + '&currentPage=' + this.currentPage});
      }
    },
    destroyed() {//离开该页面需要移除这个监听的事件
      window.removeEventListener('scroll', this.handleScroll)
    }
    ,
  }
</script>

<style lang="less" scoped>
  @import "../../assets/less/base";

  html, body, #app {
    height: 100%;
  }


  .contentbox {
    /*background-color: #f2f2f2;*/
    width: 100%;
    .conten {
      margin-top: 52px;
      ul.equipment_management  {
        background: #fff;
        padding-bottom: 1px;
        /*min-height: 96vh;*/
        margin-top: 52px;
        padding-top: 104px;
        transition: all 0.5s;
        &.show_search{
          padding-top: 140px;
        }
        li {
          background-color: #f2f2f2;
          width: 96%;
          padding: 20px 2%;
          margin: 5px 0;
          display: flex;
          /*flex-direction: column;*/
          align-items: center;
          justify-content: space-around;
          > div {
            width: 12%;
            min-width: 5%;
            text-align: center;
            cursor: pointer;
            word-wrap: break-word;
            .modify_tag{
              border-bottom: 1px #000 dotted;
              display: inline-block;
              padding: 5px;
              min-width: 50%;
            }
          }
          &.white {
            background: white;
          }
          &.header_list {
            position: fixed;
            background-color: #57c5f7;
            padding: 20px 2%;
            margin: 0;
            z-index: 9;
            top: 80px;
            border-bottom: 1px solid #b7bbbf;
            color: #fff;
            transition: all 0.5s;
            &.show_search{
              top: 112px;
            }
            > div {
              font-size: 15px;
              font-weight: bold;
            }
          }
          &.header_search {
            width: 100%;
            position: fixed;
            flex-direction: column;
            justify-items: center;
            background-color: #327594;
            margin: 0;
            padding: 10px 0;
            z-index: 9;
            top: 52px;
            border-bottom: 1px solid #b7bbbf;
            color: #fff;
            transition: all 0.5s;
            height: 10px;
            .search_input_box{
              display: none;
              width: 100%;
              cursor: auto;
              >div{
                margin: 0 20px;
              }
            }
            &.show_search{
              height: 50px;
              .search_input_box{
                display: flex;
                align-items: center;
                justify-content: center;
              }
              >i{
                transform: rotate(180deg);
              }
            }
            > i {
              transition: all 0.5s;
              font-size: 20px;
              font-weight: bold;
              cursor: pointer;
            }
          }
        }
      }
      .bottom_but {
        position: fixed;
        width: 96%;
        padding: 0 2%;
        display: flex;
        justify-content: space-between;
        bottom: 30px;
        a{
          color: #fff;
        }
      }
      .add_order_but {
        position: fixed;
        bottom: 80px;
        right: 2%;
        cursor: pointer;
        i {
          color: #67C23A;
          font-size: 48px;
        }
      }
      .signature_box {
        background: #fff;
        height: 25vh;
        width: 80vw;
        padding-top: 10%;
        text-align: center;
        @media (min-width: @screen-xs-max) {
          width: 30vw;
        }
        ul {
          padding-bottom: 20px;
          li {
            margin-top: 20px;
          }
        }
        .paymentmethodbut {
          display: flex;
          justify-items: center;
          justify-content: center;
          margin-top: 20px;
          .mint-button {
            /*margin-right: 20px;*/
            margin: 0 10px;
            cursor: pointer;
          }
        }
      }
      .add_import_excel_box{
        .signature_box {
          padding: 50px;
          height: auto;
          div{
            div{
              margin-bottom: 20px;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/orderlist_child/manage_devices.vue